export default {'PTRC': {'VarName': 'response', 'VarNameShow': 'Response',
        'class1': 'R', 'class2': 'NR',
        'class1_name': 'Response', 'class2_name': 'Non-response',
        'class1_boxplotName': 'Responsive<br>(PFS ≥ 6 months)',
        'class2_boxplotName': 'Non-responsive<br>(PFS < 6 months)',
        'pfsDaysKey': 'PFS_days',
        'pfsEventKey': ['Progression-free survival event', 'Y', 'N'],
    },
'PCC': {'VarName': 'tissue_level', 'VarNameShow': 'Tissue Level',
        'class1': 'Primary', 'class2': 'Metastasis',
        'class1_name': 'Primary', 
        'class2_name': 'Metastasis',
        'class1_boxplotName': 'Primary',
        'class2_boxplotName': 'Metastasis',
        'pfsDaysKey': 'progression_free_survival',
        'pfsEventKey': ['PFS_event_status', 1.0, 0.0],
        'overallSurvivalDaysKey': 'Overall Survival Time',
        'overallSurvivalEventsKey': ['event_status', 1.0, 0.0]
    }
}